import { Component, Input, OnInit } from '@angular/core';
import { AgentService } from '../services/agent.service';
import { AgentTrainingHandlerComponent } from './agent-training.handler';

@Component({
  selector: 'sym-agent-training',
  templateUrl: './agent-training.component.html',
  styleUrls: ['./agent-training.component.scss'],
})
export class AgentTrainingComponent extends AgentTrainingHandlerComponent implements OnInit {
  constructor(agentService: AgentService) {
    super(agentService);
  }

  ngOnInit() {}
}
